import { RefreshCw } from 'lucide-react'
import type { ComponentProps } from 'react'

import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

export interface TabRefreshButtonProps {
  onRefresh: () => void
  isFetching: boolean
  disabled?: boolean
  /** Accessible label + tooltip. Defaults to a generic "Refresh data". */
  label?: string
  className?: string
  iconClassName?: string
  variant?: ComponentProps<typeof Button>['variant']
  size?: ComponentProps<typeof Button>['size']
}

/**
 * Per-tab refresh control. A tab opts into showing this by rendering it in its
 * own header; it re-fetches the tab's data instead of reloading the browser.
 */
export function TabRefreshButton({
  onRefresh,
  isFetching,
  disabled = false,
  label = 'Refresh data',
  className,
  iconClassName,
  variant = 'ghost',
  size = 'icon-sm',
}: TabRefreshButtonProps) {
  return (
    <Button
      variant={variant}
      size={size}
      onClick={onRefresh}
      disabled={disabled || isFetching}
      aria-label={isFetching ? 'Refreshing data' : label}
      title={label}
      className={cn('shrink-0', className)}>
      {/* animate-spin-gpu, not animate-spin — see globals.css (Safari ghost). */}
      <RefreshCw
        className={cn(
          'size-[18px]',
          isFetching && 'animate-spin-gpu',
          iconClassName
        )}
      />
    </Button>
  )
}
